<h1 mat-dialog-title>Cash Register Settings</h1>
<form [formGroup]="form" mat-dialog-content>
   <div class="pt-2">
      <div class="row mb-4">
         <div class="col">Day Register</div>

         <div class="col-auto">
            <mat-slide-toggle formControlName="isDayRegister"></mat-slide-toggle>
         </div>
      </div>

      <app-select-entity-field
         type="cashRegisterLocation"
         formControlName="cashRegisterLocationId"
      ></app-select-entity-field>
   </div>
</form>

<mat-dialog-actions align="end">
   <button mat-button mat-dialog-close mat-raised-button color="accent" cdkFocusInitial (click)="onSave()">Save</button>
   <button mat-button mat-dialog-close (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
